import { AspectRatio, Image, Text } from "@chakra-ui/react";
import React from "react";

export function initials(name) {
  const [firstName, lastName] = name.split(" ");
  return firstName && lastName
    ? `${firstName.charAt(0)}${lastName.charAt(0)}`
    : firstName.charAt(0);
}

const ImgFallback = ({ name }) => {
  return (
    <Text
      layerStyle={"avatarFallback"}
      fontSize={"8xl"}
      borderRadius={"full"}
      border={"8px solid"}
      bg={"brand.primary.500"}
      borderColor={"brand.primary.300"}
    >
      {initials(name)}
    </Text>
  );
};

const KioskAvatar = ({ imageSrc, name }) => {
  return (
    <AspectRatio maxW="400px" ratio={1} m={2} layerStyle={"avatarContainer"}>
      <Image
        src={imageSrc}
        alt={name}
        layerStyle={"avatar"}
        objectFit="cover"
        borderRadius={"full"}
        border={"8px solid"}
        borderColor={"brand.primary.600"}
        fallback={<ImgFallback name={name} />}
      />
    </AspectRatio>
  );
};

export default KioskAvatar;
